define(['./_root'], function(root) {

  /** Used to detect overreaching core-js shims. */
  var coreJsData = root['__core-js_shared__'];

  return coreJsData;
});
